import { render, staticRenderFns } from "./RegisterTournament.vue?vue&type=template&id=73394618&scoped=true"
import script from "./RegisterTournament.vue?vue&type=script&lang=js"
export * from "./RegisterTournament.vue?vue&type=script&lang=js"
import style0 from "./RegisterTournament.vue?vue&type=style&index=0&id=73394618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73394618",
  null
  
)

export default component.exports